export const EXTERNAL_BROWSER_PATH = '/abrir-no-navegador';
export const AGENDA_PUBLIC_ORIGIN = 'https://agendaja.app';

export function getPublicAgendaUrl(url: URL): string {
  return `${AGENDA_PUBLIC_ORIGIN}${url.pathname}${url.search}${url.hash}`;
}

/** Esquemas privados são tentativas de saída; a identificação por User-Agent não cobre todos os aplicativos. */
export function getExternalBrowserUrl(destination: string, userAgent: string): string | null {
  if (/bot|crawler|spider|facebookexternalhit|preview/i.test(userAgent)) return null;

  const isAndroid = /Android/i.test(userAgent);
  const isIos = /iPhone|iPad|iPod|Macintosh.*Mobile/i.test(userAgent);
  if (!isAndroid && !isIos) return null;

  // O WhatsApp também usa WAiOS/ e WA4A/; no iPhone o restante do UA pode ser igual ao Safari.
  // A mesma lista de marcadores está em AgendaJa.Back EmbeddedBrowserUserAgent. As duas andam juntas.
  const knownApp =
    /Instagram|WhatsApp|\b(?:WAiOS|WA4A)\/|FBAN|FBAV|Messenger|Barcelona|Threads|TikTok|musical_ly|BytedanceWebview|Twitter|Snapchat|LinkedInApp|Telegram|MicroMessenger|Line\/|GSA\//i;
  const androidWebView = isAndroid && /;\s*wv\)|Version\/4\.0/i.test(userAgent);
  const iosWebView = isIos && /AppleWebKit/i.test(userAgent) && !/Safari\/|CriOS\/|FxiOS\/|EdgiOS\/|OPiOS\//i.test(userAgent);
  if (!knownApp.test(userAgent) && !androidWebView && !iosWebView) return null;

  let url: URL;
  try {
    url = new URL(destination);
  } catch {
    return null;
  }
  if (!/^https?:$/.test(url.protocol) || url.username || url.password) return null;
  const publicUrl = getPublicAgendaUrl(url);

  if (isAndroid) {
    // Sem package: o Android escolhe o navegador padrão, sem exigir Chrome instalado.
    return `intent://${publicUrl.slice('https://'.length)}#Intent;scheme=https;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end`;
  }

  if (/Instagram/i.test(userAgent)) return `instagram://extbrowser/?url=${encodeURIComponent(publicUrl)}`;
  if (/Barcelona|Threads/i.test(userAgent)) return `barcelona://extbrowser/?url=${encodeURIComponent(publicUrl)}`;
  // Nos demais WebViews do iOS, este esquema tenta abrir Safari especificamente.
  return publicUrl.replace('https:', 'x-safari-https:');
}

/** Bloqueia o bootstrap, inclusive quando um Service Worker devolve o shell em cache. */
export function redirectEmbeddedBrowser(browser: Window): boolean {
  if (!getExternalBrowserUrl(browser.location.href, browser.navigator.userAgent)) return false;
  if (browser.location.pathname === EXTERNAL_BROWSER_PATH) return true;

  const handoff = new URL(EXTERNAL_BROWSER_PATH, AGENDA_PUBLIC_ORIGIN);
  handoff.searchParams.set('returnTo', getPublicAgendaUrl(new URL(browser.location.href)));
  handoff.searchParams.set('ngsw-bypass', 'true');
  browser.location.replace(handoff.href);
  return true;
}
